import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PhoneIssuesChipAndMenuModule } from 'src/app/common-components/phone-issues-chip-and-menu/phone-issues-chip-and-menu.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { PhoneRegisterModule } from '../phone-register/phone-register.module';
import { ExtensionPhoneRegisterComponent } from './containers/extension-phone-register.component';
import { ExtensionPhoneRegisterEffects } from './state/extension-phone-register.effects';
import {
   extensionPhoneRegisterFeatureKey,
   extensionPhoneRegisterReducer,
} from './state/extension-phone-register.reducer';
import { ExtensionPhoneRegisterViewComponent } from './views/extension-phone-register-view.component';

@NgModule({
   declarations: [ExtensionPhoneRegisterComponent, ExtensionPhoneRegisterViewComponent],
   exports: [ExtensionPhoneRegisterComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      PhoneIssuesChipAndMenuModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      ReactiveFormsModule,
      RouterModule,
      MatMenuModule,
      ScrollingModule,
      RegisterModule,
      PhoneRegisterModule,
      MatSnackBarModule,
      EffectsModule.forFeature([ExtensionPhoneRegisterEffects]),
      StoreModule.forFeature(extensionPhoneRegisterFeatureKey, extensionPhoneRegisterReducer),
   ],
})
export class ExtensionPhoneRegisterModule {}
